import { AxiosResponse } from 'axios';
import { goBack } from 'connected-react-router';
import {
  all,
  call,
  CallEffect,
  fork,
  put,
  PutEffect,
  takeEvery,
} from 'redux-saga/effects';
import FaraGostarDynamicHttp from '../../api/FaraGostarDynamicHttp';
import { ActionTypes } from '../../constants/ActionTypes';
import { ShowError, ShowSuccess } from '../../helper/Alert';
import {
  ILetterSignatureAccess,
  IRetriveLetter,
  ISaveAndSignLetter,
} from '../../interfaces/Signature';
import { getLocaleMsg } from '../../lngProvider';
import {
  checkCanConfirmLetterSuccess,
  fetchSignatureListSuccess,
  onRetriveLetterSuccess,
  onSignLetterSuccess,
} from '../actions';

const getSignatureList = async (
  letterCode: string,
  secretariatToSecretariatFormatId: number,
  signIndex: number,
  search: string,
) => {
  const http = await FaraGostarDynamicHttp();
  return await http.get(
    `sign/GetEmployeePositionSignatures?letterCode=${letterCode}&secretariatToSecretariatFormatId=${secretariatToSecretariatFormatId}&signIndex=${signIndex}&search=${search}`,
  );
};

const retriveApi = async (action: IRetriveLetter) => {
  const http = await FaraGostarDynamicHttp();
  return await http.post('Sign/SignRetrieve', action);
};

const confirmApi = async (
  letterCode: string,
  letterSignaturePathId: number,
  isConfirmed: boolean,
  description: string,
) => {
  const http = await FaraGostarDynamicHttp();
  return await http.post('confirm/AddLetterConfirm', {
    letterCode: letterCode,
    isConfirmed: isConfirmed,
    letterSignaturePathId: letterSignaturePathId,
    description: description,
  });
};

const removeConfirmApi = async (
  letterCode: string,
  letterSignaturePathId: number,
  letterConfirmId: number,
) => {
  const http = await FaraGostarDynamicHttp();
  return await http.post('confirm/removeLetterConfirm', {
    letterCode: letterCode,
    letterSignaturePathId: letterSignaturePathId,
    letterConfirmId: letterConfirmId,
  });
};

const signApi = async (action: ISaveAndSignLetter) => {
  const http = await FaraGostarDynamicHttp();
  return await http.post('Sign/SaveAndSignLetter', action);
};

function* fetchSignatureListRequest(
  action: any,
): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<any>
> {
  try {
    const fetchedSignatureList = yield call(
      getSignatureList,
      action.payload.letterCode,
      action.payload.secretariatToSecretariatFormatId,
      action.payload.signIndex,
      action.payload.search,
    );
    yield put(fetchSignatureListSuccess(fetchedSignatureList.data));
  } catch (error) {
    ShowError('', error);
  }
}

export function* fetchSignatureList() {
  yield takeEvery(ActionTypes.GET_SIGNATURE_LIST, fetchSignatureListRequest);
}

function* confirmLetterRequest(action: any) {
  const messages = getLocaleMsg();
  try {
    yield call(
      confirmApi,
      action.payload.letterCode,
      action.payload.letterSignaturePathId,
      action.payload.isConfirmed,
      action.payload.description,
    );
    ShowSuccess('', messages['draft.approveCase']);
    yield put(goBack());
  } catch (error) {
    ShowError('', error);
  }
}

export function* onConfirm() {
  yield takeEvery(ActionTypes.CONFIRM_LETTER, confirmLetterRequest);
}

function* removeConfirmLetterRequest(action: any) {
  const messages = getLocaleMsg();
  try {
    yield call(
      removeConfirmApi,
      action.payload.letterCode,
      action.payload.letterSignaturePathId,
      action.payload.letterConfirmId,
    );
    ShowSuccess('', messages['draft.removeApprove']);
    yield put(goBack());
  } catch (error) {
    ShowError('', error);
  }
}

export function* onRemoveConfirm() {
  yield takeEvery(
    ActionTypes.REMOVE_CONFIRM_LETTER,
    removeConfirmLetterRequest,
  );
}

function* signLetterRequest(action: any) {
  const messages = getLocaleMsg();
  try {
    yield call(signApi, action.payload);
    ShowSuccess('', messages['draft.SignLetter']);
    yield put(onSignLetterSuccess());
  } catch (error) {
    ShowError('', error);
  }
}

export function* onSigneLetter() {
  yield takeEvery(ActionTypes.SIGN_LETTER, signLetterRequest);
}

function* retriveLetterRequest(action: any) {
  const messages = getLocaleMsg();
  try {
    yield call(retriveApi, action.payload);
    ShowSuccess('', messages['messages.RetrieveSignature']);
    yield put(onRetriveLetterSuccess());
  } catch (error) {
    ShowError('', error);
  }
}

export function* onRetriveLetter() {
  yield takeEvery(ActionTypes.RETRIVE_LETTER, retriveLetterRequest);
}

const checkCanConfirmApi = async (action: ILetterSignatureAccess) => {
  const http = await FaraGostarDynamicHttp();
  return await http.get(
    `sign/checkCanConfirmLetter?letterCode=${action.letterCode}&signatureIndex=${action.signatureIndex}`,
  );
};

function* checkCanConfirmLetterRequest(
  action: any,
): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<any>
> {
  try {
    const result = yield call(checkCanConfirmApi, action.payload) as any;
    yield put(checkCanConfirmLetterSuccess(result.data));
  } catch (error) {
    ShowError('', error);
  }
}

export function* onCheckCanConfirm() {
  yield takeEvery(
    ActionTypes.CHECK_CAN_CONFIRM_LETTER,
    checkCanConfirmLetterRequest,
  );
}

export default function* rootSaga() {
  yield all([
    fork(fetchSignatureList),
    fork(onConfirm),
    fork(onRemoveConfirm),
    fork(onSigneLetter),
    fork(onRetriveLetter),
    fork(onCheckCanConfirm),
  ]);
}
